export default {
  h1: {
    fontSize: { base: '2xl', lg: '4xl' },
    lineHeight: { base: 'short', lg: 'shorter' },
    fontWeight: { base: 'light', lg: 'light' },
  },
  h2: {
    fontSize: { base: '2xl', lg: '3xl' },
    lineHeight: { base: 'short' },
    fontWeight: { base: 'light', lg: 'light' },
  },
  h3: {
    fontSize: { base: 'lg', lg: '2xl' },
    lineHeight: { base: 'short' },
    fontWeight: { base: 'light', lg: 'light' },
  },
  h4: {
    fontSize: { base: 'md', lg: 'xl' },
    lineHeight: { base: 'short' },
    fontWeight: { base: 'bold', lg: 'light' },
  },
  h5: {
    fontSize: { base: 'md', lg: 'md' },
    lineHeight: { base: 'short' },
    fontWeight: { base: 'bold' },
  },
  h6: {
    fontSize: { base: 'sm', lg: 'sm' },
    lineHeight: { base: 'short' },
    fontWeight: { base: 'bold' },
  },
};
